/* 🤖 this file was generated by svg-to-ts */
export const matIconLocalHotel: {
  name: 'local-hotel';
  data: string;
} = {
  name: 'local-hotel',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"/></svg>`
};
